export default function EarlyAccessBanner() {
  return (
    <section className="py-20 px-6 lg:px-12 relative overflow-hidden">
      {/* Subtle gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#304FFE]/[0.05] via-transparent to-[#7C4DFF]/[0.05]"></div>

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="bg-white rounded-3xl shadow-lg border-2 border-transparent bg-clip-padding relative overflow-hidden">
          {/* Gradient border effect */}
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-r from-[#304FFE] to-[#7C4DFF] opacity-20"></div>
          
          <div className="relative bg-white rounded-3xl p-12 text-center">
            {/* Icon */}
            <div className="w-14 h-14 bg-gradient-to-br from-[#304FFE] to-[#7C4DFF] rounded-xl flex items-center justify-center mx-auto mb-6 shadow-lg">
              <i className="ri-vip-crown-line text-2xl text-white"></i>
            </div>

            {/* Title */}
            <h3 className="text-3xl lg:text-4xl font-bold text-[#1A1F36] mb-4">
              Get Early Access
            </h3>

            {/* Description */}
            <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8 leading-relaxed">
              Join the first group of learners and be the first to unlock MicroSkills, badges and personalized pathways.
            </p>

            {/* CTA Button */}
            <button className="inline-flex items-center gap-3 bg-gradient-to-r from-[#304FFE] to-[#7C4DFF] text-white font-bold px-10 py-5 rounded-full hover:shadow-[0_20px_40px_rgba(124,77,255,0.3)] hover:scale-105 transition-all duration-300 cursor-pointer whitespace-nowrap text-lg">
              Join the Waitlist
              <i className="ri-arrow-right-line text-2xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
